import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
// import { SessionService } from '../../session.service';
import { environment } from '../../../environments/environment';
import { FlashMessagesService } from 'angular2-flash-messages';
import Swal from 'sweetalert2';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
	selector: 'app-resetpassword',
	templateUrl: './resetpassword.component.html',
	styleUrls: ['./resetpassword.component.css'],
})
export class ResetpasswordComponent implements OnInit {
	resetPasswordForm: FormGroup;
	submitted = false;
	iserror: any = false;
	errormsg: any;
	apiUrl: any;
	username: any = localStorage.getItem('username');
	fieldTextType1: boolean;
	fieldTextType2: boolean;
	fieldTextType3: boolean;

	selfportal_application_id = environment.APPLICATION_ID;
	userEmail: string;

	// tslint:disable-next-line: max-line-length
	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private router: Router,
		// private sess: SessionService,
		private flashMessage: FlashMessagesService,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	ngOnInit(): void {
		// this.sess.islogin();
		this.initForm();
		this.userEmail = localStorage.getItem('username');

		this.resetPasswordForm = this.formBuilder.group(
			{
				emailAddress: [
					this.userEmail,
					[
						Validators.required,
						Validators.maxLength(45),
						Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
					],
				],
				oldPassword: ['', [Validators.required, Validators.minLength(6)]],
				newPassword: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(
							'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
						),
					],
				],
				confirmPassword: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(
							'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
						),
					],
				],
			},
			{
				validator: MustMatch('newPassword', 'confirmPassword'),
			}
		);
	}

	initForm() {
		this.resetPasswordForm = this.formBuilder.group(
			{
				emailAddress: [
					'',
					[
						Validators.required,
						Validators.maxLength(45),
						Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
					],
				],
				oldPassword: ['', [Validators.required, Validators.minLength(6)]],
				newPassword: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(
							'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
						),
					],
				],
				confirmPassword: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(
							'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
						),
					],
				],
			},
			{
				validator: MustMatch('newPassword', 'confirmPassword'),
			}
		);
	}

	onSubmitResetPassword(formAllData: any) {
		// alert('hiiiii');
		this.submitted = true;

		if (this.resetPasswordForm.invalid) {
			return;
		}

		const obj = {
			email: formAllData.emailAddress,
			default_password: formAllData.oldPassword,
			password: formAllData.newPassword,
			password_confirmation: formAllData.confirmPassword,
			// username: localStorage.getItem('otp_username'),
		};

		console.log('resetPasswordData: ', formAllData);
		this.resetDefaultPassword(obj);
	}

	resetDefaultPassword(jsonData: any) {
		this.apiUrl = environment.AUTHAPIURL + 'auth/signup/password/reset';

		this.spinnerService.show();
		this.http.post<any>(this.apiUrl, jsonData).subscribe((data) => {
			console.log('resetPasswordApiResponse: ', data);

			if (data.status == true) {
				// console.log("userData: ", data.response);
				localStorage.setItem('email', data.response.user.email);
				localStorage.setItem('id', data.response.user.id);

				localStorage.setItem('access_token', data.response.access_token);

				localStorage.setItem('role_id', data.response.user.role_id);
				localStorage.setItem(
					'application_id',
					data.response.user.application_id
				);
				localStorage.setItem('phone', data.response.user.phone);
				localStorage.setItem('active', data.response.user.active);
				localStorage.setItem('name', data.response.user.name);
				localStorage.setItem(
					'application_name',
					data.response.application_name
				);
				localStorage.setItem(
					'changed_default_password',
					data.response.user.changed_default_password
				);
				localStorage.setItem('profile_image', data.response.user.profile_image);
				localStorage.setItem('created_at', data.response.user.created_at);
				localStorage.setItem('updated_at', data.response.user.updated_at);

				this.spinnerService.hide();

				if (data.response.user.application_id == 1) {
					this.router.navigate(['/lab-dashboard']);
				} else if (data.response.user.application_id == 2) {
					this.router.navigate(['/sample-center-dashboard']);
				} else if (data.response.user.application_id == 3) {
					this.router.navigate(['/ministry-dashboard']);
				}else if (data.response.user.application_id == 4) {
					this.router.navigate(['/airport-dashboard']);
				}else {
					this.router.navigate(['/dashboard']);
				}

				//this.router.navigate(['/dashboard']);
			} else {
				this.spinnerService.hide();
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: data.message,
					showConfirmButton: true,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		});
	}

	ngOnDestroy() {
		localStorage.removeItem('username');
	}

	toggleFieldTextType1() {
		this.fieldTextType1 = !this.fieldTextType1;
	}

	toggleFieldTextType2() {
		this.fieldTextType2 = !this.fieldTextType2;
	}

	toggleFieldTextType3() {
		this.fieldTextType3 = !this.fieldTextType3;
	}
}

export function MustMatch(controlName: string, matchingControlName: string) {
	return (formGroup: FormGroup) => {
		const control = formGroup.controls[controlName];
		const matchingControl = formGroup.controls[matchingControlName];

		if (matchingControl.errors && !matchingControl.errors.mustMatch) {
			// return if another validator has already found an error on the matchingControl
			return;
		}

		// set error on matchingControl if validation fails
		if (control.value !== matchingControl.value) {
			matchingControl.setErrors({ mustMatch: true });
		} else {
			matchingControl.setErrors(null);
		}
	};
}
